import { useEffect, useState } from "react";
import "./QuestionTypeSelect.css";
import { QuestionType } from "effno-core";
import { FormQuestionTag } from "../form-question/FormQuestionTag";
import { QuestionTypeDisplay } from "../form-question/FormQuestionTag";

type QuestionTypeSelectProps = {
    selected: QuestionType;
    disabled?: boolean;
    onChange: (type: QuestionType) => void;
}

export const QuestionTypeSelect = ({selected, disabled=true, onChange} : QuestionTypeSelectProps) => {

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {

        const myDiv = document.getElementById("question-type-select-container");

        document.addEventListener("keydown", (event: any) => {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        });

        document.addEventListener('click', (event: any) => {
            if (myDiv && !myDiv.contains(event.target)) {
                setIsOpen(false);
            }
        });
        
        return () => {
            document.removeEventListener("keydown", (event: any) => {
                if (event.key === "Escape") {
                    setIsOpen(false);
                }
            });
            
            document.removeEventListener('click', (event: any) => {
                if (myDiv && !myDiv.contains(event.target)) {
                    setIsOpen(false);
                }
            });
        }
    }, []);

    // console.log("[QuestionTypeSelect] disabled: ", disabled);

    return (
        <div 
            className="question-type-select-container"
            style={{cursor: "unset"}}
        >
            <div 
                className="question-type-select"
                onClick={() => {
                        if (!disabled) {
                            setIsOpen(!isOpen)
                        }
                }}
            >
                <div className="question-type-select-selected">
                    <FormQuestionTag type={selected} /> {QuestionTypeDisplay[selected]}
                </div>

                {!disabled && isOpen &&
                    <div className="question-type-select-options">
                        {Object.keys(QuestionType).map((type) => {
                            return (
                                <div 
                                    key={type}
                                    className="question-type-select-option"
                                    onClick={() => {
                                        onChange(type as QuestionType);
                                        setIsOpen(false);
                                    }}
                                >
                                    <FormQuestionTag type={type as QuestionType} /> {QuestionTypeDisplay[type as QuestionType]}
                                </div>
                            )
                        }
                        )}
                    </div>
                }

            </div>
        </div>
        
    )
}